var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKzen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.57 16c0 3.574 1.197 6.768 2.413 9.086a23.896 23.896 0 0 0 1.663 2.717 17.745 17.745 0 0 0 .686.903l.035.042.007.009-.861.622-.862.62-.001-.003-.006-.005-.014-.016a7.91 7.91 0 0 1-.223-.275 19.642 19.642 0 0 1-.602-.804 25.847 25.847 0 0 1-1.802-2.943c-1.304-2.485-2.628-5.98-2.628-9.953 0-3.972 1.324-7.468 2.628-9.953a25.85 25.85 0 0 1 1.802-2.943 19.686 19.686 0 0 1 .825-1.08l.014-.016.005-.006V2l.863.621.862.623-.008.01-.035.041-.146.18c-.128.162-.314.406-.54.723a23.892 23.892 0 0 0-1.663 2.717c-1.216 2.318-2.412 5.511-2.412 9.086zM12.19 9v14H10V9h2.188z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKzen);
export default __webpack_public_path__ + "static/media/KZEN.439169ff15811c28e4a7d8a55f7fc418.svg";
export { ForwardRef as ReactComponent };